import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sem-not-found',
    templateUrl: './sem-not-found.component.html',
    styleUrls: ['./sem-not-found.component.css'],
    standalone: false
})
export class SemNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
